import { Link } from 'react-router-dom';
import { Heart, Phone, Mail, MapPin } from 'lucide-react';

const CurvedTop = () => (
  <div className="absolute -top-1 left-0 right-0">
    <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" preserveAspectRatio="none">
      <path d="M0 60C480 0 960 0 1440 60V60H0V60Z" fill="hsl(215 50% 16%)" />
    </svg>
  </div>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-[hsl(215,50%,16%)] text-white/80 pt-4" data-testid="footer">
      <CurvedTop />
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-3 gap-10 md:gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="inline-block" data-testid="footer-logo">
              <div className="font-fredoka font-bold text-2xl">
                <span className="text-primary">Hoo</span>
                <span className="text-secondary">yo's</span>
                <span className="text-accent"> Place</span>
              </div>
            </Link>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              Nurturing young minds through loving care, fun learning, and safe exploration in the Portland/Beaverton Metro Area.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-fredoka font-bold text-lg text-white">
              Quick Links
            </h3>
            <div className="space-y-2.5">
              <button
                onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-white/60 hover:text-primary transition-colors text-sm"
                data-testid="footer-about-link"
              >
                About Us
              </button>
              <button
                onClick={() => document.getElementById('programs')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-white/60 hover:text-primary transition-colors text-sm"
                data-testid="footer-programs-link"
              >
                Our Programs
              </button>
              <Link
                to="/register"
                className="block text-white/60 hover:text-primary transition-colors text-sm"
                data-testid="footer-enroll-link"
              >
                Enroll Now
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="font-fredoka font-bold text-lg text-white">
              Contact Us
            </h3>
            <div className="space-y-3">
              <a href="tel:971-867-0536" className="flex items-center gap-2.5 text-white/60 hover:text-primary transition-colors text-sm" data-testid="footer-phone">
                <Phone className="w-4 h-4 flex-shrink-0" />
                971-867-0536
              </a>
              <a href="mailto:hooyosplace26@gmail.com" className="flex items-center gap-2.5 text-white/60 hover:text-primary transition-colors text-sm" data-testid="footer-email">
                <Mail className="w-4 h-4 flex-shrink-0" />
                hooyosplace26@gmail.com
              </a>
              <div className="flex items-start gap-2.5 text-white/60 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>Portland / Beaverton Metro Area, Oregon</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-sm text-center md:text-left">
              &copy; {currentYear} Hooyo's Place. All rights reserved.
            </p>
            <Link to="/admin" className="text-white/20 hover:text-white/40 transition-colors text-xs" data-testid="footer-admin-link">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
